export const TONE_SHARING_POLICY_URL = '/guides/tone-sharing-guidelines';

export const MODERATION_ANNOUNCEMENT_MODAL_DISMISSED_KEY = 'moderationAnnouncementModalDismissed';
export const TONE_SHARING_POLICY_MODAL_DISMISSED_KEY = 'toneSharingPolicyModalDismissed';

export function isModerationAnnouncementModalDismissed(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(MODERATION_ANNOUNCEMENT_MODAL_DISMISSED_KEY) === 'true';
}

export function dismissModerationAnnouncementModal() {
  if (typeof window === 'undefined') return;
  localStorage.setItem(MODERATION_ANNOUNCEMENT_MODAL_DISMISSED_KEY, 'true');
}

export function isToneSharingPolicyModalDismissed(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(TONE_SHARING_POLICY_MODAL_DISMISSED_KEY) === 'true';
}

export function dismissToneSharingPolicyModal() {
  if (typeof window === 'undefined') return;
  localStorage.setItem(TONE_SHARING_POLICY_MODAL_DISMISSED_KEY, 'true');
}
